import uploadImage from "../../../services/galleryService";

const handleAssetManager = (editor, setOpenLocaleStoragePopUp) => {


    editor.on('asset:update',(asset) => {
        const newAssetSize =  Math.round(asset.attributes.src.length / 1024 ) + Math.round(JSON.stringify(asset.attributes).length /1024);
        const storageSize = Math.round(JSON.stringify(localStorage).length / 1024);
        
        let maxStorageSize = 0;
        for (let i = 0, data = "m"; i < 40; i+=1) {
            try { 
                localStorage.setItem("DATA", data);
                data += data;
            } catch(e) {
                maxStorageSize = Math.round(JSON.stringify(localStorage).length / 1024);
                break;
                }
        }
        localStorage.removeItem("DATA");

        if(newAssetSize + storageSize >= maxStorageSize){
            editor.AssetManager.remove(asset);
            setOpenLocaleStoragePopUp(true);
        }
    
    })
    
    editor.on('asset:remove',(asset) => {
        const gjsAssets = JSON.parse(localStorage.getItem('gjs-assets')).filter( gjsAsset => gjsAsset.name !== asset.attributes.name).map(gjsAsset => gjsAsset);
        localStorage.setItem('gjs-assets', JSON.stringify(gjsAssets)); 
    })

    editor.on('asset',() => {
        const am = editor.AssetManager;
        am.render(
            am.getAll().filter(item => item)
        );
        editor.refresh();
    })

    // TODO break this function into smaller functions based on png of jpeg
    editor.on('asset:add', (asset) => {
      if (asset.get('src').includes('data:image/png;base64,')) {
        const newBase64String = asset.get('src').replace('data:image/png;base64,', '');
        uploadImage(newBase64String).then((imageUrl) => {
          asset.set('src', imageUrl);
        });
      } else if (asset.get('src').includes('data:image/jpeg;base64,')) {
        const newBase64String = asset.get('src').replace('data:image/jpeg;base64,', '');
        uploadImage(newBase64String).then((imageUrl) => {
          asset.set('src', imageUrl);
        });
      }
    });
}

export default handleAssetManager;
